import React from "react";

const LandingPage = React.lazy(() => import('pages/LandingPage'));
const ShoppingCart = React.lazy(() => import('pages/shoppingCart'));
const CheckoutPage = React.lazy(() => import('pages/checkout-page'));
const AllProducts = React.lazy(() => import('pages/AllProducts'));
const ProductDetail = React.lazy(() => import('pages/ProductDetail'));
const TermsServicePage = React.lazy(() => import('pages/TermsServicePage'));
const PrivacyPage = React.lazy(() => import('pages/PrivacyPage'));
const Confirmation = React.lazy(() => import('pages/checkout-page/confirm/Confirm'));
const ConfirmationPage = React.lazy(() => import('pages/checkout-page/confirmPage'));

export interface RouteItemProp {
    path: string
    element: JSX.Element;
}

export const routeItems: RouteItemProp[] = [
  {
    path: "/",
    element: <LandingPage />
  },
  {
    path: "/cart",
    element: <ShoppingCart />
  },
  {
    path: "/checkout",
    element: <CheckoutPage />
  },
  {
    path: "/confirmation/:confirmId",
    element: <Confirmation />
  },
  {
    path: "/confirmation",
    element: <ConfirmationPage />
  },
  {
    path: "/products",
    element: <AllProducts />
  },
  {
    path: "/:equipType/:equipId",
    element: <ProductDetail />
  },
  {
    path: "/terms-service",
    element: <TermsServicePage />
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPage />
  },
];
